/**
 * Logger interface for debug tracing.
 *
 * Users can provide a custom implementation to route SSH debug
 * output to their own logging infrastructure.
 */
export type Logger = {
	debug(message: string): void;
};

/**
 * Default logger that writes to console.debug.
 */
export const consoleLogger: Logger = {
	debug(message: string): void {
		console.debug(`[ssh] ${message}`);
	},
};

/**
 * No-op logger used when debug mode is disabled.
 * All methods are empty to ensure zero overhead.
 */
export const noopLogger: Logger = {
	debug(): void {},
};
